<div>
    <h2><img class="icon-small" [src]="'icons/contact-icon.png'" /> Neem contact op</h2>
    <contact-component></contact-component>
</div>